// extracted by mini-css-extract-plugin
export default {"form":"ProjectForm_form__ReOk1"};